import React from 'react';

const InfoMessage = ({ text }) => {
  return (
    <div className="settings-text-helper">
      <p>💡 {text}</p>
    </div>
  );
};

export default InfoMessage;